import cookieDetails from "./details/";

const modul = angular
    .module("modalComponents", [])

    .directive("cookieDetails", cookieDetails);

export default modul.name;
